// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_page__yYIFO {
    /*display: flex;*/
    /*grid-gap: 20px;*/
    /*justify-content: center;*/
    /*align-items: flex-start;*/
    margin: 0 auto;
    max-width: 100%;
    width: var(--container-width);
    padding: 24px 30px 34px;
}

.storage_pageRow__WxCD0 {
    display: flex;
    flex-wrap: wrap;
    grid-gap: 92px;
    justify-content: center;
}

.storage_box__9H-Ih {
    padding: 0 30px;
    background: #fff;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    width: 1257px;
    /*height: 908px;*/
    position: relative;
}

.storage_actions__ptWzH {
    position: absolute;
    top: 20px;
    right: 20px;
}

.storage_content__7chmn {
    display: flex;
    flex-direction: column;
    /*grid-gap: 200px;*/
    height: 908px;
    padding: 56px 60px 46px;

    --box-width: clamp(150px, 11.15vw, 225px);
    --box-height: clamp(70px, 5.3vw, 107px);

    --box-width-sm: clamp(150px, 8vw, 170px);
    --box-height-sm: clamp(70px, 3.8vw, 85px);
}

.storage_row__jbjE5 {
    display: flex;
    justify-content: space-between;
    position: relative;
}

.storage_rowMiddle__ZGxl7 {
    /*padding-bottom: 40px;*/
    margin: auto 0;
}

.storage_rowAbsolute__o6H5Y {
    /*display: flex;*/
    /*justify-content: flex-end;*/
    /*align-items: flex-end;*/
    position: absolute;
    /*right: 30px;*/
    /*top: 160px;*/
    top: 70%;
    right: 0;
    width: 254px;
}

.storage_rowAbsolute__o6H5Y.storage_bottom__WMl68 {
    top: initial;
    bottom: 0;
}

/*.rowAbsolute > div {*/
/*    margin: auto !important;*/
/*}*/

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .storage_content__7chmn {
        --box-width-sm: clamp(150px, 8vw, 200px);
        --box-height-sm: clamp(70px, 3.8vw, 95px);
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .storage_box__9H-Ih {
        padding: 0 80px;
    }

    .storage_rowAbsolute__o6H5Y {
        /*right: 80px;*/
        width: 202px;
    }
}

/* .rowAbsolute:not(:last-child) {
        top: 120px;
    }*/

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    /*.page {*/
    /*    grid-gap: 20px;*/
    /*}*/

    .storage_box__9H-Ih {
        /*padding: 0 40px;*/
    }

    .storage_rowAbsolute__o6H5Y {
        top: 100%;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} and (max-height: 800px) {
    .storage_content__7chmn {
        max-height: calc(100vh - var(--header-height) - 100px);
        height: calc(100vh - var(--header-height) - 100px);
    }
}

@media (max-height: 1260px) and (min-height: 800px) {
    /*.box,*/
    .storage_content__7chmn {
        max-height: calc(100vh - var(--header-height) - 120px);
        height: calc(100vh - var(--header-height) - 120px);
    }

    .storage_content__7chmn {
        /*grid-gap: 18vh;*/
        padding: 76px 40px 40px;
    }

    .storage_rowAbsolute__o6H5Y:last-child {
        /*bottom: 35px;*/
    }
}

@media (max-height: 840px) {
    .storage_content__7chmn {
        /*min-height: 660px;*/
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} and (max-height: 918px) {
    .storage_content__7chmn {
        min-height: 730px;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-sm-max"]} {
    .storage_content__7chmn {
        padding-left: 0px;
        padding-right: 0px;
    }
}

/*@media (max-height: 1000px) and (min-height: 980px) {*/
/*    .content {*/
/*        grid-gap: 18vh;*/
/*        padding: 80px 0 20px;*/
/*    }*/
/*}*/
`, "",{"version":3,"sources":["webpack://./src/pages/Storage/StorageView/storage.module.css"],"names":[],"mappings":"AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;IAC3B,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yCAAyC;IACzC,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;;IAEvB,yCAAyC;IACzC,uCAAuC;;IAEvC,wCAAwC;IACxC,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,QAAQ;IACR,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA,uBAAuB;AACvB,+BAA+B;AAC/B,IAAI;;AAEJ;IACI;QACI,wCAAwC;QACxC,yCAAyC;IAC7C;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;AACJ;;AAEA;;MAEM;;AAEN;IACI,UAAU;IACV,sBAAsB;IACtB,IAAI;;IAEJ;QACI,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,sDAAsD;QACtD,kDAAkD;IACtD;AACJ;;AAEA;IACI,QAAQ;IACR;QACI,sDAAsD;QACtD,kDAAkD;IACtD;;IAEA;QACI,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA,wDAAwD;AACxD,iBAAiB;AACjB,0BAA0B;AAC1B,gCAAgC;AAChC,QAAQ;AACR,IAAI","sourcesContent":["@value screen-sm-max, screen-md-max, screen-lg-min from '../../../breakpoints.css';\n\n.page {\n    /*display: flex;*/\n    /*grid-gap: 20px;*/\n    /*justify-content: center;*/\n    /*align-items: flex-start;*/\n    margin: 0 auto;\n    max-width: 100%;\n    width: var(--container-width);\n    padding: 24px 30px 34px;\n}\n\n.pageRow {\n    display: flex;\n    flex-wrap: wrap;\n    grid-gap: 92px;\n    justify-content: center;\n}\n\n.box {\n    padding: 0 30px;\n    background: #fff;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n    width: 1257px;\n    /*height: 908px;*/\n    position: relative;\n}\n\n.actions {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n}\n\n.content {\n    display: flex;\n    flex-direction: column;\n    /*grid-gap: 200px;*/\n    height: 908px;\n    padding: 56px 60px 46px;\n\n    --box-width: clamp(150px, 11.15vw, 225px);\n    --box-height: clamp(70px, 5.3vw, 107px);\n\n    --box-width-sm: clamp(150px, 8vw, 170px);\n    --box-height-sm: clamp(70px, 3.8vw, 85px);\n}\n\n.row {\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n}\n\n.rowMiddle {\n    /*padding-bottom: 40px;*/\n    margin: auto 0;\n}\n\n.rowAbsolute {\n    /*display: flex;*/\n    /*justify-content: flex-end;*/\n    /*align-items: flex-end;*/\n    position: absolute;\n    /*right: 30px;*/\n    /*top: 160px;*/\n    top: 70%;\n    right: 0;\n    width: 254px;\n}\n\n.rowAbsolute.bottom {\n    top: initial;\n    bottom: 0;\n}\n\n/*.rowAbsolute > div {*/\n/*    margin: auto !important;*/\n/*}*/\n\n@media screen-lg-min {\n    .content {\n        --box-width-sm: clamp(150px, 8vw, 200px);\n        --box-height-sm: clamp(70px, 3.8vw, 95px);\n    }\n}\n\n@media screen-md-max {\n    .box {\n        padding: 0 80px;\n    }\n\n    .rowAbsolute {\n        /*right: 80px;*/\n        width: 202px;\n    }\n}\n\n/* .rowAbsolute:not(:last-child) {\n        top: 120px;\n    }*/\n\n@media screen-md-max {\n    /*.page {*/\n    /*    grid-gap: 20px;*/\n    /*}*/\n\n    .box {\n        /*padding: 0 40px;*/\n    }\n\n    .rowAbsolute {\n        top: 100%;\n    }\n}\n\n@media screen-md-max and (max-height: 800px) {\n    .content {\n        max-height: calc(100vh - var(--header-height) - 100px);\n        height: calc(100vh - var(--header-height) - 100px);\n    }\n}\n\n@media (max-height: 1260px) and (min-height: 800px) {\n    /*.box,*/\n    .content {\n        max-height: calc(100vh - var(--header-height) - 120px);\n        height: calc(100vh - var(--header-height) - 120px);\n    }\n\n    .content {\n        /*grid-gap: 18vh;*/\n        padding: 76px 40px 40px;\n    }\n\n    .rowAbsolute:last-child {\n        /*bottom: 35px;*/\n    }\n}\n\n@media (max-height: 840px) {\n    .content {\n        /*min-height: 660px;*/\n    }\n}\n\n@media screen-lg-min and (max-height: 918px) {\n    .content {\n        min-height: 730px;\n    }\n}\n\n@media screen-sm-max {\n    .content {\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n}\n\n/*@media (max-height: 1000px) and (min-height: 980px) {*/\n/*    .content {*/\n/*        grid-gap: 18vh;*/\n/*        padding: 80px 0 20px;*/\n/*    }*/\n/*}*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-sm-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-sm-max"]}`,
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"page": `storage_page__yYIFO`,
	"pageRow": `storage_pageRow__WxCD0`,
	"box": `storage_box__9H-Ih`,
	"actions": `storage_actions__ptWzH`,
	"content": `storage_content__7chmn`,
	"row": `storage_row__jbjE5`,
	"rowMiddle": `storage_rowMiddle__ZGxl7`,
	"rowAbsolute": `storage_rowAbsolute__o6H5Y`,
	"bottom": `storage_bottom__WMl68`
};
export default ___CSS_LOADER_EXPORT___;
